/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['@media only screen and (max-width: 1023px) {\n    .common-form.with-mobile-transformation[_ngcontent-%COMP%]   .columns[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%] > span[_ngcontent-%COMP%] {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC91c2VyLW1hbmFnZW1lbnQvdXNlci1wcm9maWxlL2Jsb2Nrb3V0L2Jsb2Nrb3V0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL3VzZXItbWFuYWdlbWVudC91c2VyLXByb2ZpbGUvYmxvY2tvdXQvYmxvY2tvdXQuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-profile/blockout/blockout.component.css.shim.ngstyle.ts